import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// We are adding specific engineering icons here:
import { faMicrochip, faLaptopCode, faTools } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

// SECTION 1: CONTROLS
const labelsFirst = [
    "Nonlinear MPC (NMPC)",
    "Hierarchical RL",
    "Automated PID Tuning",
    "Python (NumPy, SciPy, PyTorch)",
    "Optimal Control"
];

// SECTION 2: MODELING
const labelsSecond = [
    "Graph-Based Modeling",
    "Thermal Systems",
    "System Identification",
    "MATLAB & Simulink",
    "Machine Learning"
];

// SECTION 3: VALIDATION & PROTOTYPING
// I combined the best tags from Validation AND Manufacturing here
const labelsThird = [
    "HIL / SIL Validation",
    "LABVIEW",
    "5-Axis CNC & CAM",
    "Automated Data Analysis",
    "Rapid Prototyping",
    "Engine Dyno Testing"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                
                {/* 1. CONTROLS */}
                <div className="skill">
                    <FontAwesomeIcon icon={faMicrochip} size="3x"/>
                    <h3>Advanced Control Strategies</h3>
                    <p>
                        Specializing in <strong>Hierarchical Reinforcement Learning</strong> and <strong>Nonlinear Model Predictive Control (NMPC)</strong>. 
                        I design robust architectures that optimize competing objectives under stochastic uncertainty, such as the two-layer PPO agent I engineered for BEV thermal management.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                {/* 2. MODELING */}
                <div className="skill">
                    <FontAwesomeIcon icon={faLaptopCode} size="3x"/>
                    <h3>Physics-Based Modeling</h3>
                    <p>
                        Developing novel <strong>graph-based modeling approaches</strong> and semi-empirical predictive models (Patent-Pending). 
                        I synthesized high-fidelity dynamic models for thermal architectures in under one hour and reduced computation time by 2,500x using Deep Learning surrogates.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                {/* 3. VALIDATION & PROTOTYPING */}
                <div className="skill">
                    <FontAwesomeIcon icon={faTools} size="3x"/>
                    <h3>Validation & Prototyping</h3>
                    <p>
                        From virtual <strong>HIL/SIL verification</strong> to physical <strong>5-axis CNC manufacturing</strong>. 
                        I bridge the gap between theory and reality by engineering automated data pipelines for validation and leveraging DFM principles to build functional hardware prototypes.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

            </div>
        </div>
    </div>
    );
}

export default Expertise;